// resources/js/app.js

// Zorg dat Vite/Sage assets worden opgepikt
import.meta.glob(['../images/**', '../fonts/**']);

/* =========================
   1) UI – Header
   ========================= */
// Mount hamburger/off-canvas header + (optionele) sidebar menu
import mountHeaderUI from './ui/header/index.js';

/* =========================
   2) Componenten & Blocks
   ========================= */
import { mount as mountComponents } from './components/index.js';
import { mount as mountBlocks }     from './blocks/index.js';

/* =========================
   3) WooCommerce bundels
   ========================= */
// LET OP: mini-cart export is default (niet named)
import mountMiniCart from './woocommerce/mini-cart/index.js';

import { mount as mountAccount }  from './woocommerce/account/index.js';
import { mount as mountArchive }  from './woocommerce/archive/index.js';
import { mount as mountSingle }   from './woocommerce/single/index.js';
import { mount as mountCart }     from './woocommerce/cart/index.js';
import { mount as mountCard }     from './woocommerce/card/index.js';
import { mount as mountCheckout } from './woocommerce/checkout/index.js';

/* =========================
   4) Helper: safe runner
   ========================= */
function safeRun(fn, label) {
  try {
    typeof fn === 'function' && fn();
  } catch (e) {
    console.error(`[Boot] ${label} failed`, e);
  }
}

/* =========================
   5) Boot
   ========================= */
function boot() {
  // Guard tegen dubbel initialiseren
  if (window.__wkAppBooted) return;
  window.__wkAppBooted = true;

  // Volgorde: globale UI → generieke componenten/blocks → Woo
  safeRun(mountHeaderUI,  'header-ui');

  safeRun(mountComponents, 'components');
  safeRun(mountBlocks,     'blocks');

  // Mini cart vaak vroeg nodig (icon/badge etc.)
  safeRun(mountMiniCart,   'mini-cart');

  // WooCommerce secties (elk bestand checkt zelf of het op de juiste pagina is)
  safeRun(mountAccount,    'account');
  safeRun(mountArchive,    'archive');
  safeRun(mountSingle,     'single');
  safeRun(mountCart,       'cart');
  safeRun(mountCard,       'card');
  safeRun(mountCheckout,   'checkout');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
